import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { BC_SOLANA, BlockchainInfos, globalUserInfos } from '../lib/blockchainSession.ts';
import NavBarInfos from './navBarInfos.tsx';
import NavBarWalletList from './walletlist.tsx';
import EngineConfig from './engineconfig';
import { ScreenChange } from '../lib/game.ts';
import ValidateWallet from './validateSession.tsx';
import NavBarConfig from './configbar.tsx';

export type ActiveNavLink = {
    selectCar: Boolean;
    lobby: Boolean;
    play: Boolean;
    garage: Boolean;
    restart: Boolean;
}

type BalanceProp = {
    blockchaininfos: BlockchainInfos
    userInfos: globalUserInfos
    screenChanger: ScreenChange | null
    activeLinks: ActiveNavLink
    setBCInfos: Dispatch<SetStateAction<BlockchainInfos>>
}

const NavBarBalance = (props: BalanceProp): ReactNode => {

    const screenChanger = props.screenChanger;

    const [configSelect, setConfigSelect] = useState<number>(0);

    return (<div><nav id="navbar_top" className="navbar navbar-expand-lg navbar-dark bg-dark text-white ">
        
        <div className="container-fluid">
            <table className='w-100'>
                <tbody>
                <tr><td><a className="navbar-brand" href="/">Crazy Cars</a></td>
                <td>
                    <button onClick={()=> setConfigSelect(1) }><img className='setting-icon' src="assets/img/display-icon.jpg" alt="gfx"/></button>
                    <button onClick={()=> setConfigSelect(2) }><img className='setting-icon' src="assets/img/audio-icon.svg" alt="sfx"/></button>
                    <button onClick={()=> setConfigSelect(3) }><img className='setting-icon' src="assets/img/gamepad-icon.png" alt="sfx"/></button>                    
                </td>
                <td>
                    <table id="navbar-table">
                        <tbody>
                            <tr>
                                {props.activeLinks.selectCar ? (<td><a className="nav-link" href="/select-car">my cars</a></td>) : (<td></td>)}
                                {props.activeLinks.garage ? (<td><a className="nav-link" href="/garage">garage</a></td>) : (<td></td>)}
                                {props.activeLinks.play ? (<td><a className="nav-link" onClick={()=> localStorage.setItem("lastScreen", "lobby") } href="/play">play</a></td>) : (<td></td>)}

                                <td>
                                    <div className='container-fluid'>
                                        <div className='row'>
                                            <div id="my-nitro-balance" className='col-sm-3 nav-balance text-left'  >
                                                <img className="nitro-icon" src="assets/img/nitro-icon.png" alt="nitro"></img>
                                                <span className="balance-info">{props.userInfos && props.userInfos.userInfos ? props.userInfos.userInfos.nitros : '-'}</span>
                                            </div>
                                            <div id="my-tech-balance" className='col-sm-3 nav-balance text-left' >
                                                <img className="tech-icon" src="assets/img/tech-icon.png" alt="tech"></img>
                                                <span className="balance-info">{props.userInfos && props.userInfos.userInfos ? props.userInfos.userInfos.techBalance : '-'}</span>
                                            </div>
                                            <div id="my-balance" className='col-sm-3 nav-balance text-left'>
                                                {props.blockchaininfos.bc_type == BC_SOLANA ? (<img className="solana-token-icon" src="assets/img/solana-icon.png"></img>) : (<img className="wax-token-icon" src="assets/img/wax-icon.png"></img>)}
                                                <span className="balance-info">{props.userInfos && props.userInfos ? props.userInfos.balance.main : '-'}</span>
                                            </div>
                                            <div id="my-steel-balance" className="col-sm-3 nav-balance text-left">
                                                <img className="steel-token-icon" src="assets/img/steel-icon.png"></img>
                                                <span className="balance-info">{props.userInfos && props.userInfos ? props.userInfos.balance.stl : '-'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="userinfos">{props.blockchaininfos.logType >= 0 ? (<NavBarInfos setBCInfos={props.setBCInfos} blockchaininfos={props.blockchaininfos} />) : (<NavBarWalletList blockchaininfos={props.blockchaininfos} setBCInfos={props.setBCInfos} />)}</td>
                                    {screenChanger !== null ? (
                                    <td>
                                        {props.activeLinks.lobby ? (<button onClick={() => { if (screenChanger?.current?.getName() === 'lobby') return; screenChanger?.changeScreen('lobby', true); }} className="btn btn-primary">lobby</button>) : (<span></span>)}
                                        {props.activeLinks.restart ? (<button onClick={() => { if (screenChanger?.current?.getName() === 'play') { screenChanger.current.restartLevel() } }} className="btn btn-primary">restart</button>) : (<span></span>)}
                                    </td>
                                ) : (<td></td>)
                                }

                            </tr>
                            <tr><td colSpan={13} align='right' className='text-right'>
                                {
                                    props.blockchaininfos.validated ?
                                        (<img src="assets/img/verifiedWallet.webp" className="verified-wallet-icon" alt="verified" />)
                                        :
                                        (<ValidateWallet blockchaininfos={props.blockchaininfos} />)
                                }
                            </td></tr>
                        </tbody>
                    </table>
                </td>
                </tr>
            </tbody>
        </table>
        </div>
     
    </nav>
       <div className='container-fluid'>
            <div className='navbar-config'><NavBarConfig set_selected={setConfigSelect} selected={configSelect} /></div>
        </div></div>);
}
export default NavBarBalance;
